import { useCallback, useEffect, useState } from 'react';
import {
  fetchAgentSourceIncludes,
  syncAgentSourceIncludes,
} from '../services/AgentSourceIncludes.service';
import {
  AgentSourceId,
  defaultAgentSourceIncludes,
} from '../types/AgentSource';

export const useAgentSourceIncludes = () => {
  const [includes, setIncludes] = useState(defaultAgentSourceIncludes);

  useEffect(() => {
    let cancelled = false;
    void fetchAgentSourceIncludes().then((remote) => {
      if (!cancelled) setIncludes(remote);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const setIncluded = useCallback((id: AgentSourceId, included: boolean) => {
    setIncludes((current) => {
      const next = { ...current, [id]: included };
      syncAgentSourceIncludes(next);
      return next;
    });
  }, []);

  return { includes, setIncluded };
};

export default useAgentSourceIncludes;
